export const saving = {
    savings: {
        enabled: true,
        _description: 'Enables the whole savings product including loading, main display',
        domesticTransfer: {
            enabled: false,
            _description: 'Enables new withdrawal from saving account',
        },
        statements: {
            enabled: true,
            _description: 'Enables the statements feature for saving products',
        },
    },
    accountCancellation: {
        enabled: false,
        _description: 'Enables the whole account cancellation flow',
    },
    savingEnvelopes: {
        enabled: true,
        _description: 'Enables the saving envelopes feature',
    },
    savingTicketingService: {
        enabled: true,
        _description: 'controls the rendering of ticketing container on product settings page',
    },
    termDepositOverview: {
        enabled: false,
        _description: 'Enables the overview page for term deposit',
    },
};
